// Social media share
document.getElementById("share-button").addEventListener("click", function() {
    var dataUrl = this.getAttribute("data-url");

    // Check if the navigator supports the share API
    if (navigator.share) {
        navigator.share({
            title: document.title,
            url: dataUrl
        }).then(() => {
            console.log('Sharing success');
        }).catch(error => {
            console.error('Error sharing:', error);
        });
    } else {
        // Fallback for browsers that don't support the share API
        // You can implement your own custom sharing functionality here
        console.log("Share API not supported");
    }
});
 // Copy URL to clipboard
       document.getElementById("copy-link-btn").addEventListener("click", function() {
            // Get the current URL
            var urlToCopy = window.location.href;

            // Create a temporary input element
            var tempInput = document.createElement("input");

            // Set the input value to the URL
            tempInput.setAttribute("value", urlToCopy);

            // Append the input to the body
            document.body.appendChild(tempInput);

            // Select the input value
            tempInput.select();

            // Copy the selected text
            document.execCommand("copy");

            // Remove the temporary input element
            document.body.removeChild(tempInput);

            // Notify the user that the link has been copied
            alert("Link copied to clipboard: " + urlToCopy);
        });